package com.nonopn.skywatcher.common.app.pages.map.model.weather

import androidx.compose.ui.graphics.Color
import com.nonopn.skywatcher.common.app.pages.sentinels.ThunderDetection
import com.nonopn.skywatcher.design.theme.AppColor
import com.nonopn.skywatcher.maps.LatLng
import com.nonopn.skywatcher.maps.MapUtils
import korlibs.time.DateTime
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ThunderDetectionActivity(
    val thunderDetectionId: Int = 0,
    val externalId: String = "",
    val latitude: Double = 0.0,
    val longitude: Double = 0.0,
    @SerialName("recTimestamp")
    val recTimestampSeconds: Long = 0L,
    val recISO: String = "",
    val pulseType: PulseType = PulseType.IC,
    val pulsePeakAmp: Int = 0,
    val pulseNumSensors: Int = 0
) {
    fun activityAge(): ActivityAge {
        val now = DateTime.nowUnixMillisLong() / 1000
        val diff = now - recTimestampSeconds

        if (diff < 0) return ActivityAge.Recent

        return when {
            diff < 5 * 60 -> ActivityAge.Recent
            diff < 10 * 60 -> ActivityAge.Moderate
            diff < 20 * 60 -> ActivityAge.Old
            else -> ActivityAge.VeryOld
        }
    }

    fun distance(detection: ThunderDetection) = MapUtils.distance(
        detection.latitude,
        detection.longitude,
        latitude,
        longitude
    )

    fun distance(distance: LatLng) = MapUtils.distance(
        distance.latitude,
        distance.longitude,
        latitude,
        longitude
    )
}

enum class ActivityAge(val color: Color) {
    Recent(AppColor.RedDarker),
    Moderate(AppColor.Red),
    Old(AppColor.Yellorange),
    VeryOld(AppColor.Yellow)
}